const SubmitPostButton = (props) => {
  const openModal = (e) => {
    e.preventDefault();
    props.setModalOpen(true);
  };

  return (
        <button className="tweet"  onClick={openModal}>Tweet</button>
  );
};

export default SubmitPostButton;